export default __webpack_public_path__ + "static/media/convoyeur.ab4bc3b7.png";